// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.benefits_about__u7xhD {
  display: grid;
  gap: var(--space-6);
  grid-template-columns: minmax(0, 1fr);
  padding-bottom: clamp(3rem, 2rem + 3vw, 5rem);
  margin-bottom: clamp(3rem, 2rem + 3vw, 5rem);
  border-bottom: 1px solid var(--color-border);
}
.benefits_aboutTitle__J758F {
  margin: 0 0 var(--space-3);
  font-size: var(--text-h3);
  font-weight: 500;
}
.benefits_aboutText__7V7Uh {
  margin: 0;
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}

.benefits_layout__BEItr {
  display: grid;
  gap: var(--space-5);
  grid-template-columns: minmax(0, 1fr);
}
.benefits_tabs__OBVgY {
  display: flex;
  gap: var(--space-2);
  overflow-x: auto;
  scrollbar-width: none;
  padding-bottom: var(--space-1);
}
.benefits_tabs__OBVgY::-webkit-scrollbar {
  display: none;
}
.benefits_tab__JGHaI {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 0.6rem 1rem 0.6rem 0.6rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  background: var(--color-paper);
  font-family: var(--font-sans);
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--color-text-muted);
  cursor: pointer;
  text-align: left;
  transition: background var(--dur-fast) ease, color var(--dur-fast) ease, border-color var(--dur-fast) ease;
}
.benefits_tab__JGHaI:hover {
  border-color: var(--color-ink);
  color: var(--color-ink);
}
.benefits_tab__JGHaI[aria-selected="true"] {
  background: var(--color-ink);
  border-color: var(--color-ink);
  color: #fff;
}
.benefits_tabIcon__D4cZA {
  width: 2rem;
  height: 2rem;
  padding: 0.2rem;
  border-radius: 50%;
  background: var(--color-ink);
}
.benefits_panel__ulZy6 {
  min-width: 0;
  background: var(--color-ink);
  color: #fff;
  border-radius: 0 var(--radius-lg) var(--radius-lg) var(--radius-lg);
  padding: clamp(1.75rem, 1rem + 3vw, 3.5rem);
  min-height: 18rem;
}
.benefits_panelInner__ixVLh {
  display: grid;
  gap: var(--space-5);
  grid-template-columns: minmax(0, 1fr);
}
.benefits_panelIcon__PljjJ {
  width: clamp(4.5rem, 3rem + 5vw, 7.5rem);
  height: auto;
}
.benefits_panelNum__K2wmr {
  margin: 0 0 var(--space-3);
  font-size: var(--text-caption);
  font-weight: 700;
  letter-spacing: 0.1em;
  color: var(--kur-gold);
  font-variant-numeric: tabular-nums;
}
.benefits_panelTitle__FLrhM {
  margin: 0 0 var(--space-4);
  font-size: clamp(1.75rem, 1.25rem + 1.4vw, 2.4rem);\$1letter-spacing: var(--tracking-subheading);
}
.benefits_panelText__ukc9m {
  margin: 0;
  max-width: 40rem;
  font-size: var(--text-body-lg);
  line-height: var(--leading-body);
  color: var(--color-text-muted-on-dark);
}

@media (min-width: 900px) {
  .benefits_about__u7xhD {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-8);
  }
}
@media (min-width: 992px) {
  .benefits_layout__BEItr {
    grid-template-columns: 17rem minmax(0, 1fr);
    gap: var(--space-6);
    align-items: stretch;
  }
  .benefits_tabs__OBVgY {
    flex-direction: column;
    overflow: visible;
  }
  .benefits_tab__JGHaI {
    border-radius: var(--radius-md);
    padding: 0.75rem 1rem 0.75rem 0.75rem;
  }
  .benefits_panelInner__ixVLh {
    grid-template-columns: auto minmax(0, 1fr);
    gap: var(--space-7);
    align-items: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/PHYSICIANS/SECTIONS/BENEFITS/benefits.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,4CAA4C;EAC5C,4CAA4C;AAC9C;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,0GAA0G;AAC5G;AACA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,WAAW;EACX,mEAAmE;EACnE,2CAA2C;EAC3C,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,wCAAwC;EACxC,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,kDAAkD,CAAC,4CAA4C;AACjG;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE;IACE,gDAAgD;IAChD,mBAAmB;EACrB;AACF;AACA;EACE;IACE,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,+BAA+B;IAC/B,qCAAqC;EACvC;EACA;IACE,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".about {\n  display: grid;\n  gap: var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n  padding-bottom: clamp(3rem, 2rem + 3vw, 5rem);\n  margin-bottom: clamp(3rem, 2rem + 3vw, 5rem);\n  border-bottom: 1px solid var(--color-border);\n}\n.aboutTitle {\n  margin: 0 0 var(--space-3);\n  font-size: var(--text-h3);\n  font-weight: 500;\n}\n.aboutText {\n  margin: 0;\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n\n.layout {\n  display: grid;\n  gap: var(--space-5);\n  grid-template-columns: minmax(0, 1fr);\n}\n.tabs {\n  display: flex;\n  gap: var(--space-2);\n  overflow-x: auto;\n  scrollbar-width: none;\n  padding-bottom: var(--space-1);\n}\n.tabs::-webkit-scrollbar {\n  display: none;\n}\n.tab {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 0.6rem 1rem 0.6rem 0.6rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-pill);\n  background: var(--color-paper);\n  font-family: var(--font-sans);\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  cursor: pointer;\n  text-align: left;\n  transition: background var(--dur-fast) ease, color var(--dur-fast) ease, border-color var(--dur-fast) ease;\n}\n.tab:hover {\n  border-color: var(--color-ink);\n  color: var(--color-ink);\n}\n.tab[aria-selected=\"true\"] {\n  background: var(--color-ink);\n  border-color: var(--color-ink);\n  color: #fff;\n}\n.tabIcon {\n  width: 2rem;\n  height: 2rem;\n  padding: 0.2rem;\n  border-radius: 50%;\n  background: var(--color-ink);\n}\n.panel {\n  min-width: 0;\n  background: var(--color-ink);\n  color: #fff;\n  border-radius: 0 var(--radius-lg) var(--radius-lg) var(--radius-lg);\n  padding: clamp(1.75rem, 1rem + 3vw, 3.5rem);\n  min-height: 18rem;\n}\n.panelInner {\n  display: grid;\n  gap: var(--space-5);\n  grid-template-columns: minmax(0, 1fr);\n}\n.panelIcon {\n  width: clamp(4.5rem, 3rem + 5vw, 7.5rem);\n  height: auto;\n}\n.panelNum {\n  margin: 0 0 var(--space-3);\n  font-size: var(--text-caption);\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: var(--kur-gold);\n  font-variant-numeric: tabular-nums;\n}\n.panelTitle {\n  margin: 0 0 var(--space-4);\n  font-size: clamp(1.75rem, 1.25rem + 1.4vw, 2.4rem);$1letter-spacing: var(--tracking-subheading);\n}\n.panelText {\n  margin: 0;\n  max-width: 40rem;\n  font-size: var(--text-body-lg);\n  line-height: var(--leading-body);\n  color: var(--color-text-muted-on-dark);\n}\n\n@media (min-width: 900px) {\n  .about {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--space-8);\n  }\n}\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: 17rem minmax(0, 1fr);\n    gap: var(--space-6);\n    align-items: stretch;\n  }\n  .tabs {\n    flex-direction: column;\n    overflow: visible;\n  }\n  .tab {\n    border-radius: var(--radius-md);\n    padding: 0.75rem 1rem 0.75rem 0.75rem;\n  }\n  .panelInner {\n    grid-template-columns: auto minmax(0, 1fr);\n    gap: var(--space-7);\n    align-items: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"about": `benefits_about__u7xhD`,
	"aboutTitle": `benefits_aboutTitle__J758F`,
	"aboutText": `benefits_aboutText__7V7Uh`,
	"layout": `benefits_layout__BEItr`,
	"tabs": `benefits_tabs__OBVgY`,
	"tab": `benefits_tab__JGHaI`,
	"tabIcon": `benefits_tabIcon__D4cZA`,
	"panel": `benefits_panel__ulZy6`,
	"panelInner": `benefits_panelInner__ixVLh`,
	"panelIcon": `benefits_panelIcon__PljjJ`,
	"panelNum": `benefits_panelNum__K2wmr`,
	"panelTitle": `benefits_panelTitle__FLrhM`,
	"panelText": `benefits_panelText__ukc9m`
};
export default ___CSS_LOADER_EXPORT___;
